import { Link as RouterLink } from 'react-router-dom';
// @mui
import { styled, alpha } from '@mui/material/styles';
import { Box, Link, Typography } from '@mui/material';
// auth
import { useAuthContext } from '../../../auth/useAuthContext';
// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import { CustomAvatar } from '../../../components/custom-avatar';
import { useState, useEffect } from 'react';

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: alpha(theme.palette.grey[500], 0.12),
}));

// ----------------------------------------------------------------------

export default function NavAccount() {
  const { user } = useAuthContext();
  // const skillsAgentsData = useSelector(state => state.skills.skillsAgents);
  // const [tableData, setTableData] = useState(useSelector(state => state.skills.skillsAgents));
  const [theAvatar, updateTheAvatar] = useState("/assets/unknownUser.jpeg");


  useEffect(() => {
    if(user.avatar){
      updateTheAvatar(user.avatar);
    }else{
      updateTheAvatar("/assets/unknownUser.jpeg")
    }
  }, []);

  // Si recsData a de nouvelles valeurs :
  // useEffect(() => {
  //   if (skillsAgentsData && skillsAgentsData.length > 0) {
  //     console.log("skillsAgentsData : ", skillsAgentsData)
  //     // setTableData(skillsAgentsData) // tous les fichiers (même les anciens)
  //     // setLoading({loading : false})
  //   }
  // }, [skillsAgentsData]);

  return (
    <Link to={PATH_DASHBOARD.user.account} component={RouterLink} underline="none" color="inherit">
      <StyledRoot>
        <CustomAvatar src={user?.photoURL} alt={user?.displayName} name={user?.displayName} />

        <Box sx={{ ml: 2, minWidth: 0 }}>
          <Typography variant="subtitle2" noWrap>
            {user.customMongoUser.userBotAdminFirstname} {user.customMongoUser.userBotAdminLastname}
          </Typography>

          <Typography variant="body2" noWrap sx={{ color: 'text.secondary' }}>
            {user?.role}
          </Typography>
        </Box>
      </StyledRoot>
    </Link>
  );
}
